import { render, staticRenderFns } from "./BaseBox.vue?vue&type=template&id=19c3bfc2"
import script from "./BaseBox.vue?vue&type=script&lang=js"
export * from "./BaseBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports